import { db } from './firebase';
import { store } from './store'

export default {
  getAllMeetingSuites(meetingId) {
    db.collection('meetings').doc(meetingId).collection('suites').get()
      .then(resp => {
        const suitesData = resp.docs.reduce((suitesObj, suite) => {
          if (!suitesObj[suite.id]) {
            suitesObj[suite.id] = suite.data()
          }
          return suitesObj
        }, {})

        store.commit('setMeetingSuites', suitesData)
      })
  },

  getSuiteActiveSchedule(meeting, suiteId) {
    return new Promise((resolve, reject) => {
      db
        .collection('meetings')
        .doc(meeting.id)
        .collection('suites')
        .doc(suiteId)
        .get()
        .then(resp => {
          const suiteDoc = resp.data()
          if (Object.keys(suiteDoc).length && Object.keys(suiteDoc.appointment_slots).length) {
            resolve(suiteDoc.appointment_slots);
          } else {
            resolve(meeting.appointment_slots);
          }

          reject(new Error('No slots'))
        })
    });
  },

  getUserMeetings() {
    if (store.getters.user.isAdmin) {
      return db.collection('meetings');
    } else {
      return db.collection('meetings').where('phase_index', '>', 0);
    }
  },

  getUpcomingMeetings() {
    return db.collection('meetings').where('phase_index', '==', 0).where('scheduler_date', '>', new Date())
  },

  getUserSuiteDocs(meetingId) {
    let userMeeting = store.getters.user.meetings[meetingId];
    if (!userMeeting) return []

    let userSuites = Object.keys(userMeeting.suites);
    if (!userSuites) return []

    return userSuites.map(suiteId => {
      return db.collection('meetings').doc(meetingId).collection('suites').doc(suiteId);
    })
  },

  getUserWriteableSuiteDocs(meetingId) {
    let userMeeting = store.getters.user.meetings[meetingId];
    if (!userMeeting) return []

    let userSuites = Object.keys(userMeeting.suites);
    if (!userSuites) return []

    return userSuites
    .filter(suiteId => {
      return userMeeting.suites[suiteId]
    })
    .map(suiteId => {
      return db.collection('meetings').doc(meetingId).collection('suites').doc(suiteId);
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/dbhelpers.js